import { render, staticRenderFns } from "./DevStatus2Nwk.vue?vue&type=template&id=5fe3f9af&scoped=true"
import script from "./DevStatus2Nwk.vue?vue&type=script&lang=js"
export * from "./DevStatus2Nwk.vue?vue&type=script&lang=js"
import style0 from "./DevStatus2Nwk.vue?vue&type=style&index=0&id=5fe3f9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3f9af",
  null
  
)

export default component.exports